var _ClientSideComponent;
import { lazy, Suspense } from "react";
import ClientSideComponent from "../../../ClientSideComponent";
import { jsx as _jsx } from "react/jsx-runtime";
var LazyRightSectionWrapper = /*#__PURE__*/lazy(function () {
  return import(/* webpackChunkName: "main-menu-right-section-wrapper" */"./RightSectionWrapper");
});
var RightSectionWrapper = function RightSectionWrapper() {
  return _ClientSideComponent || (_ClientSideComponent = /*#__PURE__*/_jsx(ClientSideComponent, {
    children: /*#__PURE__*/_jsx(Suspense, {
      fallback: null,
      children: /*#__PURE__*/_jsx(LazyRightSectionWrapper, {})
    })
  }));
};
export default RightSectionWrapper;